import Vue from 'vue'
import Vuex from 'vuex'
import {BridgeNativeMethods} from '@/assets/js/jsbridge'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    refreshToken: '',
    userData:null
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setRefreshToken(state, refreshToken) {
      state.refreshToken = refreshToken
    },
    setUserData(state,data) {
      state.userData = data
    }
  },
  actions: {
    updateToken({commit}, token) {
      commit('setToken', token)
      BridgeNativeMethods.updateToken(token)
    },
    logout() {
      BridgeNativeMethods.logout()
    }
  },
  modules: {
  }
})
